module.exports = __webpack_public_path__ + "img/Ball Aerospace.da32754c.png";